import { AddGroupCourseArgs, CreateGroupArgs, EditGroupArgs, IGroup } from "../../common/group";
import { deleteGroupUser } from "./sagas";
import {ACTION_TYPES} from "./types";
export default {
    fetchGroups() {
        return {
            type: ACTION_TYPES.FETCH_GROUPS,
        }
    },
    addGroup(payload: CreateGroupArgs) {
        return {
            type: ACTION_TYPES.ADD_GROUP,
            payload,
        }
    },
    deleteGroup(payload: IGroup['id']) {
        return {
            type: ACTION_TYPES.DELETE_GROUP,
            payload,
        }
    },
    editGroup(payload: EditGroupArgs) {
        return {
            type: ACTION_TYPES.EDIT_GROUP,
            payload,
        }
    },
    getGroupCourses(payload: IGroup['id']) {
        return {
            type: ACTION_TYPES.GET_GROUP_COURSES,
            payload,
        }
    },
    deleteGroupUser({id, userId}: {id: IGroup['id'], userId: string}) {
        return {
            type: ACTION_TYPES.DELETE_GROUP_USER,
            payload: {id, userId}
        }
    },
    addGroupUser({id, userId}: {id: IGroup['id'], userId: string}) {
        return {
            type: ACTION_TYPES.ADD_GROUP_USER,
            payload: {id, userId}
        }
    },
    addGroupCourse(payload: AddGroupCourseArgs) {
        return {
            type: ACTION_TYPES.ADD_GROUP_COURSE,
            payload,
        }
    },
    deleteGroupCourse(payload: AddGroupCourseArgs) {
        return {
            type: ACTION_TYPES.DELETE_GROUP_COURSE,
            payload,
        }
    }
}
